import React, {Component} from 'react';
import Popup from "../../../components/popup";

import { ButtonCancel, ButtonProceed, ButtonReturn } from '../../../components/buttons';

import PopupContext from '../../../context/context-popup';
import Container from '../../../layouts/containers/container';
import InputsTextarea from '../../../components/inputs/inputs-text-area';

import List from '../../../components/list';
import meetingsApi from '../../../lib/meetings/meetings-api';
import alertManager from '../../../managers/alert/alert-manager';
import LabelContainer from '../../../components/label-container';
import ErrorContainer from '../../../components/error-container';
import Cross from '../../../components/buttons/cross';
import dayjs from 'dayjs';

import isBetween from 'dayjs/plugin/isBetween';

import humanizeDuration from 'humanize-duration';
import eventsApi from '../../../lib/events/events-api';

dayjs.extend(isBetween)

export default class PopupsDeleteMember extends Component {
    static contextType = PopupContext;

    constructor(props) {
        super(props);
    }

    update() {

    }

    render() {
        return (
            <Popup>
                <Popup.Content>
                    <Container.Text fontSize="30px" color="#151515">Are you sure you wish to remove this member from your company?</Container.Text>
                </Popup.Content>

                <Popup.Buttons>
                    <ButtonProceed onClick={this.update.bind(this)}>Confirm</ButtonProceed>
                    <ButtonReturn onClick={this.context.closePopup} rightIcon={<Cross/>}>Return To Booking</ButtonReturn>
                    <ButtonProceed>Contact us to discuss</ButtonProceed>
                </Popup.Buttons>
            </Popup>
        );
    }
}
